<template lang="html">
  <transition name="modal-fade">
    <div class="modal-background">

      <div id="group-edit-content" class="container white-box col-lg-4 col-md-4 col-sm-6 col-11" role="dialog">

        <header>
          <h4 class="text-center">{{ groupData.name }}</h4>
      	  <p id="group-edit-content-explain-sr" class="sr-only">Afhak de emner du ønsker at tilføje til gruppen</p>
        </header>

      	<section>
      		<ul id="group-edit-content-tabs" class="col-12 no-pad-both-xs">
      			<li class="col-4 grey-text" role="tab" :class="{'active' : activeTab == 'links'}" @click="activeTab = 'links'" tabindex="0">Links</li>
      			<li class="col-4 grey-text" role="tab" :class="{'active' : activeTab == 'places'}" @click="activeTab = 'places'" tabindex="0">Steder</li>
      			<li class="col-4 grey-text" role="tab" :class="{'active' : activeTab == 'groups'}" @click="activeTab = 'groups'" tabindex="0">Temaer</li>
      		</ul>

      		<ul class="col-12 group-add-list" v-show="activeTab == 'links'">
            <li v-show="favoriteData.link.length == 0">Du har endnu ingen favoritlinks, du kan føje til dine samlinger.</li>
            <template v-for="(child, index) in favoriteLinks">
              <EditGroupContentChild :childData="child" :userGroupContent="userGroupContent" @toggleItem="changeGroupContent"></EditGroupContentChild>
            </template>
          </ul>

      		<ul class="col-12 group-add-list" v-show="activeTab == 'places'">
            <li v-show="favoriteData.place.length == 0">Du har endnu ingen favoritsteder, du kan føje til dine samlinger.</li>
            <template v-for="(child, index) in favoritePlaces">
              <EditGroupContentChild :childData="child" :userGroupContent="userGroupContent" @toggleItem="changeGroupContent"></EditGroupContentChild>
            </template>
          </ul>

      		<ul class="col-12 group-add-list" v-show="activeTab == 'groups'">
            <li v-show="favoriteData.themes.length == 0">Du har endnu ingen favorittemaer, du kan føje til dine samlinger.</li>
            <template v-for="(child, index) in favoriteGroups">
              <EditGroupContentChild :childData="child" :userGroupContent="userGroupContent" @toggleItem="changeGroupContent"></EditGroupContentChild>
            </template>
          </ul>

      	</section>

      	<footer class="text-center">
      		<button class="grey btn col-5" @click="$emit('close');">Annuller</button>
      		<button class="blue btn col-5" @click="addContentToGroup();">Gem</button>
      	</footer>

      </div>

    </div>
  </transition>
</template>

<script>
import Profile from '@/assets/profile/Profile.js'
import EditGroupContentChild from '@/components/profile/EditGroupContentChild.vue'

export default {
  data() {
    return {
      activeTab: 'places',
      favoriteData: {
        'address': [],
        'link': [],
        'place': [],
        'themes': [],
      },
      userGroupContent: [],
    }
  },
  computed: {
    favoriteLinks() {
      return this.favoriteData.link.filter(function(item) {
        return !item.itemBroke && !item.archived;
      })
    },
    favoritePlaces() {
      return this.favoriteData.place.filter(function(item) {
        return !item.itemBroke && !item.archived;
      })
    },
    favoriteGroups() {
      return this.favoriteData.themes.filter(function(item) {
        return !item.itemBroke && !item.archived;
      })
    }
  },
  props: {
    groupData: {}
  },
  components: {
    EditGroupContentChild,
  },
  created() {
    Profile.getUserData().then((data) => {
      Profile.getLikeData(data.likes).then((finalData) => {
        this.favoriteData = finalData;
        //console.log('Favoritedata', this.favoriteData);
        for(var i in this.favoriteData) {
          for(var k = 0; k < this.favoriteData[i].length; k++) {
            for(var j = 0; j < this.groupData.likes.length; j++) {
              if(this.favoriteData[i][k].type == this.groupData.likes[j].type && this.favoriteData[i][k].value == this.groupData.likes[j].value) {
                this.userGroupContent.push(this.favoriteData[i][k]);
              }
            }
          }
        }
        //console.log(this.userGroupContent);
      });
    });
  },
  mounted() {
    console.log('Groupdata', this.groupData);
  	this.$HelperFunctions.setScreenReaderFocus('group-edit-content-explain-sr');
  },
  methods: {
    changeGroupContent(options) {
      var itemRemoved = false;
      for(var i = 0; i < this.userGroupContent.length; i++) {
        if(this.userGroupContent[i].type == options.type && this.userGroupContent[i].value == options.value) {
          this.userGroupContent.splice(i, 1);
          itemRemoved = true;
        }
      }
      if(!itemRemoved) {
        for(var i in this.favoriteData) {
          for(var k = 0; k < this.favoriteData[i].length; k++) {
            if(this.favoriteData[i][k].type == options.type && this.favoriteData[i][k].value == options.value) {
              this.userGroupContent.push(this.favoriteData[i][k]);
            }
          }
        }
      }
      //console.log(this.userGroupContent);
    },

    addContentToGroup() {
      Profile.addContentToGroup(this.groupData.id, this.userGroupContent);
      this.$emit('groupContentChanged');
  	},
  },
}
</script>

<style lang="css" scoped>
  #group-edit-content {
    padding: 10px;
  }

  section {
  	position: relative;
  	max-height: 350px;
  	overflow-y: auto;
  	/*border-bottom: 1px solid #ddd;*/
  }

  #group-edit-content-tabs {
    margin-bottom: 10px;
    text-align: center;
  }

  #group-edit-content-tabs li {
    display: inline-block;
    text-align: center;
    line-height: 48px;
    height: 48px;
    padding: 0;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    cursor: pointer;
  }

  #group-edit-content-tabs li.active {
  	border-bottom: 3px solid rgb(000,112,141);
  	color: rgb(000,112,141);
  }

  .group-add-tab-list {

  }

  footer {
    margin-top: 10px;
  }

  .btn:first-child {
    margin-right: 10px;
  }
</style>
